// extracted by mini-css-extract-plugin
module.exports = {"slideshowArrowHint":"CanvasModuleSharedPage_slideshowArrowHint__Kd4Kt","icon":"CanvasModuleSharedPage_icon__3ZnUk","tosDialog":"CanvasModuleSharedPage_tosDialog__16GzG"};